import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';

const useFormValidation = (initialState = {}) => {
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();

  // Función de validación personalizada para apellido y nombre
  const validateText = (name, value) => {
    if (!value) {
      return <Trans i18nKey={`signUp.validate.empty.${name}`}></Trans>;
    }

    // No permitir espacios antes de las primeras 3 letras
    if (value.trim().length < 3) {
      return <Trans i18nKey={`signUp.validate.short.${name}`}></Trans>;
    }

    // Verificar si tiene espacios antes de que se escriban al menos 3 letras
    const initialRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ]{3,}/;
    if (!initialRegex.test(value.trimStart())) {
      return <Trans i18nKey={`signUp.validate.characters.${name}`}></Trans>;
    }

    // Permitir letras, acentos, 'ñ' y espacios después de las 3 primeras letras
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;
    if (!regex.test(value)) {
      return <Trans i18nKey={`signUp.validate.characters.${name}`}></Trans>;
    }

    return '';
  };


  // Función de validación personalizada para validar password
  const validatePasswd = (value) => {
    if (!value) {
      return t("signUp.validate.empty.password")
    } 
    if (value.trim().length < 8) {
      return t("signUp.validate.short.password")
    }
    return '';
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setValues({
      ...values,
      [name]: value,
    });

    // Validación en tiempo real
    let errorMessage = '';
    if (name === 'lastname' || name === 'firstname') {
      errorMessage = validateText(name, value);
    } else if (name === 'password' || name === 'passwordrepeat') {
      errorMessage = validatePasswd(value);
    }

    setErrors({
      ...errors,
      [name]: errorMessage,
    });
  };

  const validate = () => {
    let tempErrors = {};
    for (let key in values) {
      if (key === 'lastname' || key === 'firstname') {
        if(validateText(key, values[key]) != '') {
          tempErrors[key] = validateText(key, values[key]);
        }
      } else if (key === 'password' || key === 'passwordrepeat') {
        if(validatePasswd(values[key]) != '') {
          tempErrors[key] = validatePasswd(values[key])
        }
      }
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  return {
    values,
    errors,
    handleChange,
    validate,
  };
};

export default useFormValidation;
